/* eslint-disable @typescript-eslint/no-explicit-any */
import { simpleSet } from '@r/reducers/utils';

const s = simpleSet as redux.reducers.language;

export const language = s(
  'SET_LANGUAGE',
  'en'
);
